var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDsStarsIcon = function SvgDsStarsIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#DSStarsIcon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.397.871a.998.998 0 0 1 1.565.526l.003.014L10.02 5.5a.67.67 0 0 0 .48.48L14.6 7.038a.998.998 0 0 1 0 1.924l-.01.003-4.09 1.054a.67.67 0 0 0-.48.48L8.96 14.604a.998.998 0 0 1-1.923 0l-.003-.014L5.98 10.5a.67.67 0 0 0-.48-.48L1.41 8.965l-.016-.005a.998.998 0 0 1 0-1.92l.015-.005L5.5 5.98a.67.67 0 0 0 .48-.48L7.04 1.398a1 1 0 0 1 .358-.526M8 2.996l.731 2.837a2 2 0 0 0 1.436 1.436L13.005 8l-2.838.731a2 2 0 0 0-1.436 1.436L8 13.005l-.731-2.838a2 2 0 0 0-1.436-1.436L2.996 8l2.837-.732a2 2 0 0 0 1.435-1.435zm5.333-1.661c.368 0 .665.298.665.665v.668h.669a.665.665 0 1 1 0 1.33h-.669v.669a.665.665 0 1 1-1.33 0v-.669H12a.665.665 0 1 1 0-1.33h.668V2c0-.367.298-.665.665-.665M2.667 10.668c.367 0 .665.298.665.665v.002h.001a.665.665 0 0 1 0 1.33h-.001v.002a.665.665 0 1 1-1.33 0v-.002H2a.665.665 0 1 1 0-1.33h.002v-.002c0-.367.297-.665.665-.665",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "DSStarsIcon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgDsStarsIcon;